import React from "react";
import { compose } from "redux";
import amlConnector from "../../../services/aml/amlConnector";
import usersConnector from "../../../services/users/usersConnector";
import JSONTree from "react-json-tree";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { amlAdminWithDev } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import UserAmlNotesComponent from "./Users.Aml.Notes.Component";

const UserAmlProfile = (props) => {
  const currentUserId = props.users.currentUser.Id;
  const currentDomain = props.users.currentUser.Domain;

  return (
    <div className="row">
      <h4>AML PROFILE</h4>
      {props.amlProfile[currentUserId]?.data && (
        <React.Fragment>
          <JSONTree
            hideRoot={true}
            data={props.amlProfile[currentUserId].data}
          />
          <ClaimsWrapper claimAuth={amlAdminWithDev}>
            <UserAmlNotesComponent currentDomain={currentDomain} />
          </ClaimsWrapper>
        </React.Fragment>
      )}
    </div>
  );
};

export default compose(amlConnector, usersConnector)(UserAmlProfile);
